import { scrollToElement } from '../../utilities';

export const scrollToFirstInvalidField = (formElem) => {
  const firstInvalid = formElem.querySelector(
    'input:invalid:not([name="recaptcha_check"])'
  );
  scrollToElement(firstInvalid);
};

export const getFormData = (formElem) => {
  const formData = new FormData(formElem);
  return Object.fromEntries(formData.entries());
};
